import { createSignal } from "solid-js";
import { useAuthentication } from "../../context/auth";
import authToken from "../../context/token";
import { useApplication } from "@/context/app";
import { logout } from "../../requests/auth";

export default function useLogout() {
  const { removeCurrentUser } = useAuthentication();
  const [loading, setLoading] = createSignal(false);
  const { token, clearToken } = authToken;
  const { successToast, errorToast } = useApplication();

  async function logoutUser() {
    try {
      setLoading(true);
      const response = await logout(token.refreshToken);
      successToast(response.message);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      removeCurrentUser();
      clearToken();
      window.location.reload();
    }
  }
  return {
    logoutUser,
    loading: loading(),
  };
}
